<template>
  <header
    class="flex items-center justify-between relative md:py-0 container mx-auto h-22"
  >
    <div class="z-50 relative">
      <NuxtLink :to="{ name: 'home' }" :aria-label="$texts('home')">
        <SpriteSymbol
          name="logo"
          alt="AOZ logo"
          class="aspect-[101/35] h-9 text-red page-landing:text-white"
        />
      </NuxtLink>
      <h2 class="sr-only">AOZ Logo</h2>
    </div>

    <VuepalTransitionHeight>
      <div
        v-show="isMenuOpen"
        class="md:!flex fixed top-0 left-0 size-full bg-darkGreenOverlay z-50 md:static md:w-auto md:left-auto md:bg-transparent"
      >
        <div>
          <PageHeaderGlobalMenu
            class="relative mt-14 md:mt-0 md:fixed md:right-10 top-4 container mx-auto"
          />
          <PageHeaderServiceMenu class="mobile-only:container" />
        </div>
      </div>
    </VuepalTransitionHeight>

    <div class="md:invisible ml-auto md:ml-0 w-28 flex justify-end z-50">
      <PageHeaderMenuButton v-model="isMenuOpen" class="menuToggleButton" />
    </div>
  </header>
</template>

<script setup lang="ts">
const isMenuOpen = ref(false)

// Close mobile menu when route changes
const route = useRoute()
watch(
  () => route.path,
  () => {
    isMenuOpen.value = false
  },
)

// Disable body scrolling when mobile menu is open
watch(isMenuOpen, (isOpen) => {
  if (import.meta.client) {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }
})

// Clean up on component unmount
onUnmounted(() => {
  if (import.meta.client) {
    document.body.style.overflow = ''
  }
})
</script>
